import React, { useEffect } from "react";
import Navbar from "../Navbar/Navbar";
import { useState } from "react";
import { API } from "../../Redux/actions/API";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import DOMPurify from "dompurify";

export default function WithdrawalDeduct() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [uId, setuId] = useState("");
  const [name, setName] = useState("");
  const [WalletType, setWalletType] = useState("");
  const [Balance, setBalance] = useState(0);
  const [Amount, setAmount] = useState("");

  const handleChange = (e) => {
    const sanitizedValue = DOMPurify.sanitize(e.target.value).replace(
      /\D/g,
      ""
    );
    const Value = sanitizedValue.slice(0, 8);

    setuId(Value);
    CheckUserId_Api(Value);
    setWalletType("");
    setBalance(0);
  };

  const CheckUserId_Api = async (value) => {
    try {
      let res = await API.post(
        "/CheckUserId",
        {
          loginid: userId,
          uid: value,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );

      if (res?.data?.data === "WrongId") {
        setName("Wrong Id");
      } else {
        setuId(value);
        setName("Valid ID");
      }
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const CheckWalletBalance_Api = async (value) => {
    try {
      setWalletType(value);
      let res = await API.post(
        "/GetWithrawalBalance",
        {
          loginid: userId,
          uid: uId,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );

      if (value === "NetIncome") {
        setBalance(res.data.data[0][0].Net_Balance);
      } else if (value === "NetIncomeworking") {
        setBalance(res.data.data[0][0].Net_BalanceWorking);
      } else {
        setBalance(0);
      }
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const handleAmount = (e) => {
    const sanitizedValue = DOMPurify.sanitize(e.target.value).replace(
      /\D/g,
      ""
    );
    const Value = sanitizedValue.slice(0, 8);

    setAmount(Value);
  };

  const BalanceDeduct_API = async () => {
    if (uId && Amount && WalletType) {
      try {
        let responceRight = await API?.post(
          "/WithdrawalDeduct",
          {
            loginid: userId,
            uid: uId,
            Income: Amount,
            type: WalletType,
          },
          {
            headers: {
              Authorization: jwt_token,
            },
          }
        );

        if (responceRight.data.data.Result == "Success!!!") {
          toast.success("Successfuly deducted!!");
          setuId("");
          setWalletType("");
          setName("");
          setBalance(0);
          setAmount(0);
        } else {
          toast.error(responceRight.data.data.Result);
        }
      } catch (e) {
        console.log("error Balance APi", e);
        if (
          e.response.data.showableMessage ==
          "Please login to access this resource"
        ) {
          dispatch(
            updateAuth({ AdminAuth: false, jwt_token: "", userId: null })
          );
          sessionStorage.clear();
          localStorage.clear();
          navigate("/");
        }
      }
    } else {
      toast.error("Please Fill All The Fields");
    }
  };

  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div
          id="content"
          class="content col-lg-12 col-sm-12 ng-scope"
          ng-controller="activateidByZeroPinCtl"
        >
          <div class="panel panel-primary">
            <div class="panel-heading">
              <h4 class="panel-title">Withdrawal Wallet Deduct</h4>
            </div>
            <div
              class="panel-body table-rep-plugin"
              style={{ padding: "8px", overflowY: "scroll" }}
            >
              <div class="row">
                <div class="box col-md-12">
                  <div class="alert alert-block alert-info">
                    <div class="row">
                      <div class="col-md-6 mr-30">
                        <div class="modal-dialog" role="document">
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="popup_net">
                                <span
                                  class="metamaskConnection"
                                  style={{ color: "#fff" }}
                                ></span>
                                <div className="d-flex justify-content-between">
                                  <h1>Withdrawal Wallet Deduct</h1>
                                  <Link
                                    to="/WithdrawalDeductHistory"
                                    id="btnactive"
                                    style={{
                                      color: "white",
                                      border: "solid 1px #ffff",
                                      padding: "10px 10px",
                                      marginTop: "20px",
                                      background: "#0d37a5",
                                    }}
                                  >
                                    Deduct History
                                  </Link>
                                </div>
                                {/* <!---onclick number increase start--> */}
                                <div className="form-group">
                                  <label>User Id</label>
                                  <input
                                    type="text"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter User Id"
                                    value={uId}
                                    onChange={handleChange}
                                  />
                                  {name && (
                                    <p
                                      className={
                                        name === "Wrong Id"
                                          ? "text-danger"
                                          : "text-success"
                                      }
                                    >
                                      {name}
                                    </p>
                                  )}
                                </div>
                                <div className="form-group">
                                  <label>Witdrawal Wallet</label>
                                  <select
                                    class="form-control"
                                    onChange={(e) =>
                                      CheckWalletBalance_Api(e.target.value)
                                    }
                                    value={WalletType}
                                  >
                                    <option value="">Select</option>
                                    <option value="NetIncome">
                                      Non-Working Income
                                    </option>
                                    <option value="NetIncomeworking">
                                      Working Income
                                    </option>
                                  </select>
                                </div>

                                <div className="form-group">
                                  <label>Wallet Balance</label>
                                  <input
                                    type="number"
                                    readOnly
                                    disabled
                                    class="form-control"
                                    placeholder="Wallet Balance"
                                    value={Balance}
                                  />
                                </div>
                                <div className="form-group">
                                  <label>Amount</label>
                                  <input
                                    type="number"
                                    inputMode="numeric"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter Amount"
                                    value={Amount}
                                    onChange={handleAmount}
                                  />
                                </div>
                                <div class="joinbtn d-flex  me-auto">
                                  <button
                                    id="btnactive"
                                    style={{
                                      color: "white",
                                      border: "solid 1px #ffff",
                                      padding: "10px 20px",
                                      marginTop: "20px",
                                    }}
                                    onClick={() => BalanceDeduct_API()}
                                  >
                                    Decuct Income
                                  </button>
                                </div>
                                {/* <div class="joinbtn d-flex flex-row-reverse me-auto">
                                  <button
                                    id="btnactive"
                                    style={{
                                      color: "white",
                                      border: "solid 1px #ffff",
                                      padding: "10px 20px",
                                      marginTop: "20px",
                                    }}
                                    onClick={() => Deduct_API()}>
                                    Fund Deduct
                                  </button>
                                </div> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
